import React from 'react';
import { Col, Row } from 'react-bootstrap';

import downloadFullAnnualReport from '../../../assets/images/downloadFullAnnualReport.png';
import CSIO_2021_Annual_Report_Lo from '../../../assets/CSIO_2020_Annual_Report_Lo.pdf';

const DownloadTheFullReport = () => {


  return (
    <Col>
      <Row>
        <Col>
          <a href={CSIO_2021_Annual_Report_Lo} aria-label="Download the annual report pdf" download style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}>
            <img
              src={downloadFullAnnualReport}
              style={{
                width: 180,
                height: 'auto',
                boxShadow: '2px 2px 2px lightgrey',
              }}
              aria-label="Download the CSIO 2021 annual report pdf"
            />
            {/* <div style={{
            width: 200,
            height: 56,
            backgroundColor: 'rgba(241, 200, 37, 0.8)',
            textAlign: 'center',
            font: 'normal normal bold 15px/19px',
            fontFamily: 'Montserrat Medium',
            letterSpacing: 1.5,
            color: '#FFFFFF',
            textTransform: 'uppercase',
            opacity: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            top: -80
          }}>
            DOWNLOAD
          </div> */}
            <div className="downloadTheAnnualReport" style={{ marginTop: 20 }}>
              DOWNLOAD the full 2020 ANNUAL REPORT PDF
          </div>
          </a>
        </Col>
      </Row>
    </Col>
  )
}

export default DownloadTheFullReport;
